import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var DollarSignCircleSVG = function DollarSignCircleSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M16 2a14 14 0 1014 14A14 14 0 0016 2zm.74 20.13v.38a1 1 0 01-2 0v-.43a3.92 3.92 0 01-3.35-2.27 1.38 1.38 0 01-.1-.49c0-.53.36-.85 1-.85a1 1 0 011 .65 3.45 3.45 0 003.26 1.49c1.39-.08 2.22-.74 2.22-1.76s-.6-1.44-2.21-1.83l-1.61-.36c-2.42-.54-3.55-1.59-3.55-3.32s1.31-3.05 3.39-3.4V9.5a1 1 0 012 0v.39c1.84.21 3.21 1.1 3.62 2.39a1.52 1.52 0 01.08.49c0 .45-.35.74-.91.74a1.09 1.09 0 01-1-.64 3.2 3.2 0 00-3-1.47c-1.25.13-2.11.78-2.11 1.7s.64 1.43 2 1.79l1.65.36c2.57.58 3.67 1.57 3.67 3.32-.04 2.34-2.06 3.36-4.05 3.56z"
  }));
};
DollarSignCircleSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(DollarSignCircleSVG);